import "./App.css";
import "./reset.css";
import TitleSlide from "./slides/title/title"
import ConceptSlide from "./slides/concept/concept"
import TeamsSlide from "./slides/teams/teams"
import JoinSlide from "./slides/join/join"
import SponsorSlide from "./slides/sponsor/sponsor"

import logo from './assets/gfx/logo.webp'
import close from './assets/gfx/close.svg'

import { useState } from "react";

function App() {
  const [menuOpen, _setMenuOpen] = useState(false);
  const [lang, _setLang] = useState(localStorage.lang ?? 'JA');

  function setLang(l) {
    localStorage.lang = l;
    _setLang(l);
  }

  function setMenuOpen(b) {
    if (b) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    _setMenuOpen(b);
  }

  return (
    <div className="App">
      <TitleSlide lang={lang} setLang={setLang} menuOpen={menuOpen} setMenuOpen={setMenuOpen}></TitleSlide>
      <ConceptSlide lang={lang}></ConceptSlide>
      <TeamsSlide></TeamsSlide>
      <JoinSlide></JoinSlide>
      <SponsorSlide lang={lang}></SponsorSlide>
      <div className={'menu ' + (menuOpen ? 'open' : '')}>
        <img width="128" onClick={() => setMenuOpen(false)} src={close} alt="close" className="close" />
        <img width="65%" src={logo} className="logo" alt="logo" />
        <div><a onClick={() => setMenuOpen(false)} href="#concept">concept</a></div>
        <div><a onClick={() => setMenuOpen(false)} href="#teams">teams</a></div>
        <div><a onClick={() => setMenuOpen(false)} href="#join">join the event</a></div>
        <div><a onClick={() => setMenuOpen(false)} href="#sponsor">sponsor</a></div>
      </div>
    </div>
  );
}

export default App;
